export var invoice_table = {
  data() {
    return {
      headers: [
        {
          text: this.$t("thead.invoice_number"),
          value: "invoice_number"
        },
        {
          text: this.$t("thead.invoice_date"),
          value: "invoice_date",
          renderer: "date"
        },
        {
          text: this.$t("thead.direct_debit_date"),
          value: "direct_debit_date",
          renderer: "date"
        },
        {
          text: this.$t("thead.total"),
          value: "total",
          renderer: "currency-cents",
          sortable: true
        },
        {
          text: "",
          value: "download",
          sortable: false,
          align: "center"
        }
      ]
    };
  }
};
